// Based on data from marketplace. Link:
// https://bitbucket.org/sembo-it/sembo.esg.share.web/src/main/apps/explore/components/bound-ux/content/footer.ts
export type MarketSpecificContent<T> = {
  host: string;
  content: T;
};
export type ContentItem = { text: string; href?: string };
type Domain = string;
type FooterContent = Record<Domain, MarketSpecificContent<ContentItem[][]>>;

export const DEFAULT_FOOTER: MarketSpecificContent<ContentItem[][]> = {
  host: 'www.sembo.co.uk',
  content: [
    [
      {
        text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
      },
      {
        text: 'Registration number: 556529-1795',
      },
      {
        text: 'Registered office: Helsingborg, Sweden',
      },
    ],
    [
      {
        text: 'Cookie settings',
        href: 'https://www.sembo.com/about-us/our-policy/',
      },
      {
        text: 'Privacy Policy',
        href: 'https://www.sembo.com/about-us/our-policy/',
      },
      {
        text: `Sembo's terms and conditions`,
        href: 'https://www.sembo.co.uk/travel-conditions',
      },
      {
        text: 'Work at Sembo',
        href: 'https://career.sembo.se/',
      },
    ],
  ],
};

export const FOOTER_CONTENT: FooterContent = {
  'www.sembo.co.uk': DEFAULT_FOOTER,
  'www.sembo.se': {
    host: 'www.sembo.se',
    content: [
      [
        {
          text: 'Org nr: 556529-1795',
        },
        {
          text: 'Momsreg. nr: SE556529179501',
        },
        {
          text: 'Styrelsens säte: Helsingborg',
        },
      ],
      [
        {
          text: 'Inställningar för cookies',
          href: 'https://www.sembo.se/om-oss/vara-policies',
        },
        {
          text: 'Resevillkor',
          href: 'https://www.sembo.se/resevillkor',
        },
        {
          text: 'Om Sembo',
          href: 'https://www.sembo.se/om-oss.aspx',
        },
        {
          text: 'Jobba på Sembo',
          href: 'https://career.sembo.se/',
        },
        {
          text: 'Login för reseagenter',
          href: 'http://agent-se.sembo.se/agent/default.aspx',
        },
        {
          text: 'Vi innehar statlig resegaranti ställd hos Kammarkollegiet',
          href: 'https://www.kammarkollegiet.se/vara-tjanster/resegaranti',
        },
      ],
      [
        {
          text: 'Flygbolag - kontakt och villkor',
          href: 'https://www.sembo.se/saa-reser-du/flyg/flygbolag.aspx',
        },
        {
          text: 'EU:s svartlistade flygbolag',
          href: 'http://ec.europa.eu/transport/modes/air/safety/air-ban/index_sv.htm',
        },
        {
          text: 'Lufttrafikföretags skadeståndsansvar vid olyckor',
          href: 'http://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2002:140:0002:0005:EN:PDF',
        },
      ],
    ],
  },
  'www.sembo.dk': {
    host: 'www.sembo.dk',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie indstillinger',
          href: 'https://www.sembo.dk/om-os/vores-policies/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.dk/kundeservice/privacy-policy/',
        },
        {
          text: `DTF Travel Rejsebetingelser`,
          href: 'https://www.sembo.dk/rejsebetingelser',
        },
        {
          text: 'Work at DTF/Sembo',
          href: 'https://career.sembo.com/',
        },
      ],
    ],
  },
  'www.sembo.de': {
    host: 'www.sembo.de',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
        },
        {
          text: 'Steuer-Nr.: 556529-1795',
        },
        {
          text: 'Sitz der Gesellschaft: Helsingborg',
        },
      ],
      [
        {
          text: 'Cookie-Einstellungen',
          href: 'https://www.sembo.de/ueber-uns/privacy-policy/',
        },
        {
          text: 'Über Sembo',
          href: 'https://www.sembo.de/ueber-uns.aspx',
        },
        {
          text: 'Datenschutzerklärung',
          href: 'https://www.sembo.de/ueber-uns/privacy-policy/',
        },
        {
          text: 'Datenschutz und Cookies',
          href: 'https://www.sembo.de/ueber-uns/datenschutz-und-cookies.aspx',
        },
        {
          text: 'Reisebedingungen',
          href: 'https://www.sembo.de/reisebedingungen',
        },
      ],
      [
        {
          text: 'Insolvenzversicherung von Stena Line Travel Group AB über Kammarkollegiet',
          href: 'https://www.sembo.de/ueber-uns/reisegarantie.aspx',
        },
      ],
    ],
  },
  'www.sembo.at': {
    host: 'www.sembo.at',
    content: [
      [
        {
          text: 'Box 1324, 251 13 HELSINGBORG',
        },
        {
          text: 'Steuer-Nr.: 556529-1795',
        },
        {
          text: 'Sitz der Gesellschaft: Helsingborg',
        },
      ],
      [
        {
          text: 'Cookie-Einstellungen',
          href: 'https://www.sembo.de/ueber-uns/privacy-policy/',
        },
        {
          text: 'Über Sembo',
          href: 'https://www.sembo.at/uberblick/',
        },
        {
          text: 'Datenschutzerklärung',
          href: 'https://www.sembo.at/uberblick/privacy-policy/',
        },
        {
          text: 'Datenschutz und Cookies',
          href: 'https://www.sembo.de/ueber-uns/datenschutz-und-cookies.aspx',
        },
        {
          text: 'Reisebedingungen',
          href: 'https://www.sembo.at/reisebedingungen',
        },
      ],
      [
        {
          text: 'Insolvenzversicherung von Stena Line Travel Group AB über Kammarkollegiet',
          href: 'https://www.sembo.de/ueber-uns/reisegarantie.aspx',
        },
      ],
    ],
  },
  'www.sembo.no': {
    host: 'www.sembo.no',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
        },
        {
          text: 'Registreringsnummer: 556529-1795',
        },
        {
          text: 'Registrert kontor: Helsingborg',
        },
      ],
      [
        {
          text: 'Innstillinger for informasjonskapsler',
          href: 'https://www.sembo.no/om-oss/vare-policies/',
        },
        {
          text: 'Om Sembo',
          href: 'https://www.sembo.no/om-oss.aspx',
        },
        {
          text: 'Retningslinjer for personvern',
          href: 'https://www.sembo.no/om-sembo/privacy-policy/',
        },
        {
          text: 'Reisevilkår',
          href: 'https://www.sembo.no/reisevilkaar',
        },
      ],
      [
        {
          text: 'Affiliate-partner',
          href: 'https://www.sembo.no/om-sembo/affiliate-partner.aspx',
        },
        {
          text: 'Work at sembo',
          href: 'https://career.sembo.se/',
        },
        {
          text: 'Innlogging for reisebyråer',
          href: 'https://sembok2.sembo.se/sembok2/login.aspx',
        },
      ],
    ],
  },
  'www.sembo.es': {
    host: 'www.sembo.es',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, Suecia',
        },
        {
          text: 'Número de registro: 556529-1795',
        },
        {
          text: 'Oficina registrada: Helsingborg, Suecia',
        },
      ],
      [
        {
          text: 'Configuración de cookies',
          href: 'https://www.sembo.es/about-us/política-de-privacidad/',
        },
        {
          text: 'Política de privacidad',
          href: 'https://www.sembo.es/about-us/política-de-privacidad/',
        },
        {
          text: 'Condiciones de viaje de Sembo',
          href: 'https://www.sembo.es/condiciones-de-viaje',
        },
        {
          text: 'Trabaja en Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.pt': {
    host: 'www.sembo.pt',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, Suécia',
        },
        {
          text: 'Número de registro: 556529-1795',
        },
        {
          text: 'Escritório registrado: Helsingborg, Suécia',
        },
      ],
      [
        {
          text: 'Configurações de cookies',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Política de privacidade',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Condições de viagem da Sembo',
          href: 'https://www.sembo.pt/condicoes-de-viagem',
        },
        {
          text: 'Trabalhe na Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },

  'www.sembo.hu': {
    host: 'www.sembo.hu',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SVÉDORSZÁG',
        },
        {
          text: 'Regisztrációs szám: 556529-1795',
        },
        {
          text: 'Székhely: Helsingborg, Svédország',
        },
      ],
      [
        {
          text: 'Cookie beállítások',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Adatvédelmi irányelvek',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Sembo szerződési feltételei',
          href: 'https://www.sembo.hu/utazasi-feltetelek',
        },
        {
          text: 'Munka a Sembonál',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.com': {
    host: 'www.sembo.com',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.com/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.nl': {
    host: 'www.sembo.nl',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, ZWEDEN',
        },
        {
          text: 'Registratie nummer: 556529-1795',
        },
        {
          text: 'Statutaire zetel: Helsingborg, Zweden',
        },
      ],
      [
        {
          text: 'Cookie instellingen',
          href: 'https://www.sembo.nl/about-us/privacy-policy/',
        },
        {
          text: 'Privacybeleid',
          href: 'https://www.sembo.nl/about-us/privacy-policy/',
        },
        {
          text: 'Reisvoorwaarden van Sembo',
          href: 'https://www.sembo.nl/reisvoorwaarden/',
        },
        {
          text: 'Werk bij Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.ie': {
    host: 'www.sembo.ie',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.ie/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.ie/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.ie/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.fi': {
    host: 'www.sembo.fi',
    content: [
      [
        {
          text: 'Stena Line Travel Group AB, Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Puh. 09 - 4255 0490 (arkisin klo 09-17)',
        },
        {
          text: 'Asiakaspalvelun sähköposti: asiakaspalvelu@sembo.fi',
        },
      ],
      [
        {
          text: 'Evästeasetukset',
          href: 'https://www.sembo.ie/about-us/our-policy/',
        },
        {
          text: 'Tietoa Sembosta',
          href: 'https://www.sembo.fi/tietoa-sembosta.aspx',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.ie/about-us/our-policy/',
        },
        {
          text: 'Matkaehdot',
          href: 'https://www.sembo.fi/matkaehdot',
        },
        {
          text: `Tietoa Sembo.fi`,
          href: 'https://www.sembo.fi/tietoa-sembosta/tietoa-sembofi.aspx',
        },
        {
          text: 'Working at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.fr': {
    host: 'www.sembo.fr',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, Suède',
        },
        {
          text: 'Numéro de registre: 556529-1795',
        },
        {
          text: 'Siège social: Helsingborg, Suède',
        },
      ],
      [
        {
          text: 'Paramètres des cookies',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Politique de confidentialité',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Conditions générales de Sembo`,
          href: 'https://www.sembo.fr/conditions-de-voyage',
        },
        {
          text: 'Travailler à Sembo',
          href: 'http://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.nz': {
    host: 'www.sembo.nz',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.nz/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.ca': {
    host: 'www.sembo.ca',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.ca/travel-conditions',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.com.au': {
    host: 'www.sembo.com.au',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.co.uk/about-us/sembo%E2%80%99s-terms-and-conditions-of-travel/',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.ch.sembo.com': {
    host: 'ch.sembo.com',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 HELSINGBORG, SCHWEDEN',
        },
        {
          text: 'Steuer-Nr.: 556529-1795',
        },
        {
          text: 'Sitz der Gesellschaft: Helsingborg',
        },
      ],
      [
        {
          text: 'Cookie-Einstellungen',
          href: 'https://ch.sembo.com/ueber-uns/privacy-policy/',
        },
        {
          text: 'Über Sembo',
          href: 'https://ch.sembo.com/ueber-uns.aspx',
        },
        {
          text: 'Datenschutzerklärung',
          href: 'https://ch.sembo.com/ueber-uns/privacy-policy/',
        },
        {
          text: 'Datenschutz und Cookies',
          href: 'https://ch.sembo.com/ueber-uns/datenschutz-und-cookies.aspx',
        },
        {
          text: 'Reisebedingungen',
          href: 'https://ch.sembo.com/reisebedingungen',
        },
      ],
      [
        {
          text: 'Insolvenzversicherung von Stena Line Travel Group AB über Kammarkollegiet',
          href: 'https://ch.sembo.com/ueber-uns/reisegarantie.aspx',
        },
      ],
    ],
  },
  'www.sembo.pl': {
    host: 'www.sembo.pl',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Polityka prywatności',
          href: 'https://www.sembo.pl/nasze-zasady',
        },
        {
          text: 'Warunki podróży',
          href: 'https://www.sembo.pl/warunki-podrozy',
        },
        {
          text: 'Kariera',
          href: 'https://career.sembo.se/',
        },
        {
          text: 'Destynacje',
          href: 'https://www.sembo.pl/miejsca',
        },
        {
          text: 'Ustawienia plików cookie',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
      ],
    ],
  },
  'www.sembo.lt': {
    host: 'www.sembo.lt',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.lt/keliones-salygos',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
  'www.sembo.si': {
    host: 'www.sembo.si',
    content: [
      [
        {
          text: 'Kungsgatan 6, 252 21 Helsingborg, SWEDEN',
        },
        {
          text: 'Registration number: 556529-1795',
        },
        {
          text: 'Registered office: Helsingborg, Sweden',
        },
      ],
      [
        {
          text: 'Cookie settings',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: 'Privacy Policy',
          href: 'https://www.sembo.com/about-us/our-policy/',
        },
        {
          text: `Sembo's terms and conditions`,
          href: 'https://www.sembo.si/pogoji-potovanja',
        },
        {
          text: 'Work at Sembo',
          href: 'https://career.sembo.se/',
        },
      ],
    ],
  },
};
